import React from "react";
import ReactDOM from "react-dom/client";
import App from "./componentes/app.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        console.log("[SW] Registered:", reg);
      })
      .catch((err) => {
        console.error("[SW] Registration failed:", err);
      });
  });
}
